/**
 * Reveals each top-level section inside #MainContent with a fade + rise as it enters the
 * viewport. Pairs with scroll-reveal.css, which only hides sections when `scroll-reveal` is
 * present on <html> (set synchronously in <head>, gated on IntersectionObserver support).
 * Each section reveals once, then is unobserved.
 */
const sections = document.querySelectorAll('#MainContent .shopify-section');

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('scroll-reveal--visible');
      observer.unobserve(entry.target);
    }
  },
  { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
);

for (const section of sections) {
  observer.observe(section);
}
